import { Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { Button, StandardDialog } from '@roc/ui';
import { LoanStore, routeByLoanSubType } from '@roc/feature-loans';
import { useHistory } from 'react-router';
import { editRouteByLoanSubType, useOneToolRoutes } from '@roc/feature-one-tool';
import { LoanSubType } from '@roc/client-portal-shared/utils';

import { useEditLoanSubmissionRoutes } from '../../hooks/useEditLoanSubmissionRoutes';

export interface EditSubmissionButtonProps {
  loanStore: LoanStore;
  loanId: any
  buttonStyle?: any
}

export const EditSubmissionButton = observer(({ loanStore, loanId, buttonStyle }: EditSubmissionButtonProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { push } = useHistory();
  const { oneToolRoutesConfig } = useOneToolRoutes();
  const { editLoanSubmissionRoutesConfig } = useEditLoanSubmissionRoutes();

  let editLoanRoute = oneToolRoutesConfig[
    editRouteByLoanSubType[loanStore?.loanDetails?.loanSubType]
  ](loanId.toString()).url;

  //For fix and flip pro we use the old screen
  if (LoanSubType.FIX_AND_FLIP_PRO === loanStore?.loanDetails?.loanSubType) {
    editLoanRoute = editLoanSubmissionRoutesConfig[routeByLoanSubType[LoanSubType.FIX_AND_FLIP_PRO]](loanId.toString()).url;
  }

  return (
    <>
      <StandardDialog
        open={dialogOpen}
        title="Warning"
        maxWidth="sm"
        handleClose={() => setDialogOpen(false)}
        dialogContent={
          <Typography align='justify'>
            Are you sure you want to continue?
            <br />
          </Typography>
        }
        dialogActions={
          <>
            <Button
              style={{ marginRight: '8px' }}
              variant="outlined"
              color="primary"
              onClick={() => { setDialogOpen(false) }}
              testId="cancelButton"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setDialogOpen(false);
                push(editLoanRoute);
              }}
              testId="confirmButton"
            >
              Confirm
            </Button>
          </>
        }
      />
      <Button
        variant="contained"
        size="small"
        onClick={() => {
          setDialogOpen(true);
        }}
        className={buttonStyle}
        color="primary"
        testId={`edit-loan-button`}
      >
        Edit Loan
      </Button>
    </>
  )
});